import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FiArrowRight } from "react-icons/fi";
import { cn } from "../../../../utils/classnames";
import { createTypographyHelper } from "../../../../utils/typography";


export const BookSection = ({ background, title, label }) => {
  const { t, i18n } = useTranslation();
  const getTypographyClass = createTypographyHelper(i18n.language);

  return (
    <div
      className={`tw:relative tw:bg-[url(${background})] tw:h-[420px] tw:lg:h-[388px] tw:bg-center tw:bg-cover tw:bg-no-repeat`}
    >
      <div className="tw:bg-[linear-gradient(268.88deg,rgba(40,40,40,0.352)_61.98%,rgba(0,0,0,0.88)_95.88%)] tw:h-full">
        <div className="tw:flex tw:flex-col tw:items-center tw:justify-center tw:gap-y-[30px] tw:h-full tw:lg:w-[550px] tw:m-auto tw:px-5 tw:lg:px-0">
          <div className="tw:flex tw:flex-col tw:gap-y-[10px] tw:lg:gap-y-3 tw:text-center tw:text-white">
            <div className="tw:font-hanken-grotesk tw:font-semibold tw:text-[8px] tw:tracking-[3px]">
              {label}
            </div>
            <div className="tw:font-libre-caslon-display tw:text-[22px] tw:leading-[26px] tw:lg:text-[34px] tw:lg:leading-[45px]">{title}</div>
          </div>
          <div className="tw:w-full">
            <Link
              to={i18n.language === "en" || i18n.language === "EN" ? "/en/book" : "/jp/book"}
              className="tw:h-[50px] tw:w-full tw:mt-[30px] tw:bg-[#D4B055] tw:rounded-md tw:text-white tw:flex tw:items-center tw:justify-center tw:gap-[10px] tw:leading-5 tw:px-6 tw:tw:hover:bg-[#b99844] tw:transition"
            >
              <div
                className={cn(
                  "tw:font-hanken-grotesk tw:font-bold tw:!text-white",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                {t("BookBanner.ButtonText")}
              </div>
              <FiArrowRight size={24} color="#ffffff" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
